export const userListColums = [
  {
    name: "Nombre",
    selector: (row) => row["first_name"],
    sortable: true,
    center: false,
  },
  {
    name: "Apellido",
    selector: (row) => row["last_name"],
    sortable: true,
    center: false,
  },
  {
    name: "Email",
    selector: (row) => row["email"],
    sortable: true,
    center: true,
  },
  {
    name: "Rol",
    selector: (row) =>
      row?.roles && row?.roles.length > 0 ? row?.roles[0].name : undefined,
    sortable: true,
    center: true,
  },
];
